import Vue from 'vue';
import VueRouter from 'vue-router';
import Cookie from 'js-cookie';
import Store from '@/store';

Vue.use(VueRouter);

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "login" */ '@/views/Login.vue')
  },
  {
    path: '/',
    name: 'Home',
    meta: { requiredAuth: true },
    redirect: '/longTerm',
    component: () => import(/* webpackChunkName: "home" */ '@/views/Home.vue'),
    children: [
      {
        path: 'longTerm',
        name: 'LongTerm',
        meta: { requiredAuth: true },
        component: () =>
          import(
            /* webpackChunkName: "longItem" */ '@/views/purviewPage/longTerm/LongTerm.vue'
          ),
        async beforeEnter(_to, _from, next) {
          try {
            await Store.dispatch(
              'longTerm/fetchOrders',
              Store.getters['longTerm/ordersPagenation']
            );

            await Store.dispatch('longTerm/fetchOrdersTotalStatus');

            next();
          } catch (err) {
            console.warn(err);
          }
        }
      },
      {
        path: 'longTermUsers',
        name: 'LongTermUsers',
        component: () =>
          import(
            /* webpackChunkName: "LongTermUsers" */ '@/views/purviewPage/longTerm/LongTermUsers.vue'
          ),
        async beforeEnter(_to, _from, next) {
          try {
            await Store.dispatch(
              'longTerm/fetchUsers',
              Store.getters['longTerm/usersPagenation']
            );

            next();
          } catch (err) {
            console.warn(err);
          }
        }
      },
      {
        path: 'longTermUserAdd',
        name: 'LongTermUserAdd',
        component: () =>
          import(
            /* webpackChunkName: "LongTermUserAdd" */ '@/views/purviewPage/longTerm/LongTermUserAdd.vue'
          ),
        async beforeEnter(_to, _from, next) {
          try {
            await Store.dispatch('longTerm/fetchServiceOptions');
            next();
          } catch (err) {
            console.log(err);
          }
        }
      },
      {
        path: 'longTermUser/:id',
        name: 'longTermUser',
        component: () =>
          import(
            /* webpackChunkName: "longTermUser" */ '@/views/purviewPage/longTerm/LongTermUser.vue'
          ),
        async beforeEnter(to, _from, next) {
          try {
            await Store.dispatch('longTerm/fetchUser', to.params.id);
            await Store.dispatch('longTerm/fetchServiceOptions');
            next();
          } catch (err) {
            console.warn(err);
          }
        }
      },
      {
        path: 'longTermReservation',
        name: 'LongTermReservation',
        component: () =>
          import(
            /* webpackChunkName: "LongTermReservation" */ '@/views/purviewPage/longTerm/LongTermReservation.vue'
          ),
        async beforeEnter(_to, _from, next) {
          try {
            await Store.dispatch('longTerm/fetchServiceOptions');
            next();
          } catch (err) {
            console.log(err);
          }
        }
      },
      {
        path: 'longTermMakeUp',
        name: 'LongTermMakeUp',
        component: () =>
          import(
            /* webpackChunkName: "LongTermMakeUp" */ '@/views/purviewPage/longTerm/LongTermMakeUp.vue'
          ),
        async beforeEnter(_to, _from, next) {
          try {
            await Store.dispatch('longTerm/fetchServiceOptions');
            next();
          } catch (err) {
            console.log(err);
          }
        }
      },
      {
        path: 'longTermOrder/:id',
        name: 'LongTermOrder',
        component: () =>
          import(
            /* webpackChunkName: "LongTermOrder" */ '@/views/purviewPage/longTerm/LongTermOrder.vue'
          ),
        async beforeEnter(to, _from, next) {
          try {
            await Store.dispatch('longTerm/fetchOrder', to.params.id);
            await Store.dispatch('longTerm/fetchServiceOptions');
            next();
          } catch (err) {
            console.warn(err);
          }
        }
      },
      {
        path: 'importOrders',
        name: 'ImportOrders',
        component: () =>
          import(
            /* webpackChunkName: "ImportOrders" */ '@/views/purviewPage/longTerm/ImportOrders.vue'
          )
      },
      {
        path: 'importUsers',
        name: 'ImportUsers',
        component: () =>
          import(
            /* webpackChunkName: "ImportUsers" */ '@/views/purviewPage/longTerm/ImportUsers.vue'
          )
      }
    ]
  }
];

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes
});

router.beforeEach(async (to, _from, next) => {
  let token = Cookie.get('token');

  if (to.matched.some(toRoute => toRoute.meta.requiredAuth) && !token) {
    next({ name: 'Login' });
  }

  next();
});

export default router;
